import React from 'react';
import '../../styles/requestConfirmed.css';


export default class RequestRescheduled extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    REQUEST RESCHEDULED
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>
                            <div className="col-sm-6 UploadPaintingCard text-center ">
                                <img className="success-gold" src={require("../../assets/success_gold_png.png")}/>

                                <p className="success-text">
                                    You have successfully scheduled the pickup. Your new pickup date is 1st August 2018
                                </p>

                                <button className="btn-black height-48 mb-25">
                                    View All Orders
                                </button>

                            </div>

                        </div>

                    </div>
                </article>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/requests_modals/request_rescheduled.js